import React, { Component } from "react";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect } from "react-router-dom";
import Card from "components/Card/Card.js";
import EditIcon from "@material-ui/icons/Edit";
import CardHeader from "components/Card/CardHeader.js";
import axios from "axios";
import Loader from "components/Loader";
import CardIcon from "components/Card/CardIcon.js";
import Constants from "../variables/Constants";
import CardBody from "components/Card/CardBody.js";
import AddAlert from "@material-ui/icons/AddAlert";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";

class AchieveGoalSection extends Component {
  state = {
    heading: "",
    actPlan: "",
    defGoal: "",
    expertFaculty: "",
    digitalLearning: "",
    easyLearning: "",
    freeStudyMaterial: "",
    redirect: false,
    notification: false,
    loading: false
  };
  componentDidMount() {
    axios.get(Constants.getUrls.achieveGoal).then(resp => {
      //console.log(resp.data);
      this.setState({
        heading: resp.data.HEADING,
        expertFaculty: resp.data.CONTENT_2,
        digitalLearning: resp.data.CONTENT_3,
        easyLearning: resp.data.CONTENT_4,
        freeStudyMaterial: resp.data.CONTENT_5,
        actPlan: resp.data.CONTENT_1,
        defGoal: resp.data.CONTENT
      });
    });
  }
  handleInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  handleSubmit = e => {
    this.setState({
      loading: true
    });
    e.preventDefault();
    let payLoad = {
      heading: this.state.heading,
      content: this.state.expertFaculty,
      content_1: this.state.digitalLearning,
      content_2: this.state.easyLearning,
      content_3: this.state.freeStudyMaterial,
      content_4: this.state.actPlan,
      content_5: this.state.defGoal
    };
    axios.post(Constants.postUrls.updateAchieveGoal, payLoad).then(() => {
      //console.log(resp);
      setTimeout(() => {
        this.setState({
          notification: false
        });
      }, 1000);
      this.setState({
        notification: true,
        loading: false
      });
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/categories"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Content Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Achieve Goal Section</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Heading"
                          inputProps={{
                            value: this.state.heading,
                            onChange: e =>
                              this.setState({ heading: e.target.value }, () => {
                                //console.log(this.state.heading);
                              })
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Clearly Defined Goal</label>
                        <br />
                        <textarea
                          name="defGoal"
                          onChange={this.handleInput}
                          className="form-control"
                          cols="119"
                          rows="6"
                          value={this.state.defGoal}
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Action Plan For Achieve Goal</label>
                        <br />
                        <textarea
                          name="actPlan"
                          onChange={this.handleInput}
                          className="form-control"
                          value={this.state.actPlan}
                          cols="119"
                          rows="6"
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Practice As Per Action Plan</label>
                        <br />
                        <textarea
                          name="expertFaculty"
                          onChange={this.handleInput}
                          value={this.state.expertFaculty}
                          className="form-control"
                          cols="119"
                          rows="6"
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Develop Personal Competance</label>
                        <br />
                        <textarea
                          name="digitalLearning"
                          onChange={this.handleInput}
                          value={this.state.digitalLearning}
                          className="form-control"
                          cols="119"
                          rows="6"
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Develop Winning Attitude</label>
                        <br />
                        <textarea
                          name="easyLearning"
                          onChange={this.handleInput}
                          value={this.state.easyLearning}
                          className="form-control"
                          cols="119"
                          rows="6"
                        ></textarea>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <label htmlFor="">Achieve The Goal</label>
                        <br />
                        <textarea
                          name="freeStudyMaterial"
                          value={this.state.freeStudyMaterial}
                          onChange={this.handleInput}
                          className="form-control"
                          cols="119"
                          rows="6"
                        ></textarea>
                      </GridItem>
                    </GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <Button className="" type="submit" color="info">
                        {this.state.loading ? (
                          <Loader />
                        ) : (
                          "Update Services Text"
                        )}
                      </Button>
                    </GridItem>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default AchieveGoalSection;
